<template>
  <div :class="$style.container">
    <VueSlickCarousel infinite autoplay :autoplay-speed="10000">
      <template #prevArrow>
        <ChevronLeftIcon />
      </template>
      <template #nextArrow>
        <ChevronRightIcon />
      </template>
      <div v-for="(item, index) in slice.items" :key="`partner-quote-${index}`" :class="$style.content">
        <PImage :class="$style.image" :image-object="item.partner_photo" />
        <div :class="$style.description">
          <div :class="$style.header">
            <PImage :class="$style.imageHeader" :image-object="item.partner_photo" />
            <div :class="$style.headerContent">
              <div>
                <RichText :text-params="item.partner_name" />
                <RichText :class="$style.partnerJobTitle" :text-params="item.partner_job_title" />
              </div>
              <PImage :class="$style.headerLogo" :image-object="item.partner_company_logo" />
            </div>
          </div>
          <RichText :text-params="item.partner_quote_content" />
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import ChevronLeftIcon from 'LkIcons/ChevronLeft.vue'
import ChevronRightIcon from 'LkIcons/ChevronRight.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import RichText from '~/components/RichText'
import PImage from '~/components/PImage'

export default {
  name: 'PartnersQuoteCarousel',
  components: {
    RichText,
    PImage,
    VueSlickCarousel,
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.container {
  max-width: 600px;
  margin: 0 40px 80px;

  @media only screen and (min-width: 700px) {
    margin: 0 auto 80px;
  }

  @include above(medium) {
    max-width: 700px;
    margin: 0 auto 80px;
  }

  @include above(large) {
    max-width: 1135px;
    margin: 80px auto 160px;
  }
}

.description {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid $gray-100;
  border-radius: 4px;

  background-color: $white;

  @include above(medium) {
    margin: 0 60px;
  }

  @include above(large) {
    flex-direction: column-reverse;
    width: 500px;
    margin: 0 0 -24px -50px;
  }
}

.content {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.image {
  display: none !important;

  @include above(large) {
    display: block !important;
    width: 330px;
    height: 330px;
    border-radius: 8px;
    object-fit: cover;
  }
}

.imageHeader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;

  @include above(medium) {
    width: 80px;
    height: 80px;
  }
  @include above(large) {
    display: none !important;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  @include above(large) {
    margin: 10px 0 0;
  }
}

.headerContent {
  display: flex;
  flex-direction: column;
  margin-left: 16px;

  @include above(large) {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-left: 0;
  }
}

.headerLogo {
  width: 75px;

  @include above(large) {
    align-self: flex-end;
    width: auto;
    height: 30px;
  }
}

.partnerJobTitle {
  margin-bottom: 8px;

  color: $gray-700;

  @include above(large) {
    margin-bottom: 0;
  }

  p {
    @include typo-sub-text;
  }
}
</style>
